import React, { useEffect } from "react";
import Header from "./components/Header/Header";
import CssBaseline from "@material-ui/core/CssBaseline";
import SideDrawer from "./components/SideDrawer/SideDrawer";
import AdminLayout from "./AdminLayout";
import { useSelector } from "react-redux";
import {getIsPanelLock} from "Helpers/analyzeToken";
import {push} from "Helpers/History";
import {read} from "Helpers/LocalStorage";

function Index(props) {
  useEffect(() => {
    const stypeU = read("StypeU");
    const IsPanelLock = getIsPanelLock();
    if (IsPanelLock) {
      if (stypeU === "1" || stypeU === "5") {
        if( props.location.pathname === "/dashboard/callback"){
          push("/dashboard/callback")
        } else if(props.location.pathname !== "/dashboard/payment" ) {
          push("/dashboard/payment")
        }
      } else {
        push("/dashboard/payment/pricing")
      }
    }
  }, [props.location.pathname]);

  return (
    <AdminLayout>
      <div className="adminLayout">
        <Header rtlLayout={read('isRTL')}/>
        <CssBaseline />
        <SideDrawer />
        <main id="main-admin-content" className={`content rtl-${read('isRTL')}`}>
          {props.children}
        </main>
      </div>
    </AdminLayout>
  );
}

export default Index;
